import { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from { 
    opacity: 0; 
  }
  
  to { 
    opacity: 1;
  } 
`;

export const rotateY = keyframes`     
  0% {
      transform: rotateY(90deg)
  }
  80% {
      transform: rotateY(-10deg)
  }
  100% {
      transform: rotateY(0)
  }
`;
